/* eslint-disable max-len */
import React from 'react';
function SendMessageOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 4C21 2.9 20.1 2 19 2H3C1.9 2 1 2.9 1 4V16C1 17.1 1.9 18 3 18H9.24167C9.54878 17.2817 9.91458 16.612 10.3442 16H2.99988V6L10.9999 11L18.9999 6V8.5L21 10.5001V4ZM18.9999 4L10.9999 8.99L2.99988 4H18.9999ZM18.5556 10V12.9333C13.1111 13.6667 10.7778 17.3333 10 21C11.9444 18.4333 14.6667 17.26 18.5556 17.26V20.2667L24 15.1333L18.5556 10Z" })));
}
export default SendMessageOutlined;
